import { useLocalSearchParams } from 'expo-router'
import { LeaderBoardScreen } from '@/screens/new-design/LeaderBoardScreen'
import { LeaderBoardScreenConvex } from '@/screens/new-design/LeaderBoardScreenConvex';

export default function () {
  const params = useLocalSearchParams<{ gameId?: string; userId?: string }>()

  // If gameId is provided (from Convex game), use Convex Leaderboard
  if (params.gameId) {
    return <LeaderBoardScreenConvex />
  }

  // Otherwise use legacy Leaderboard
  return <LeaderBoardScreen />
}
